<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
<!-- Outside ion-app so it stays above every Ionic modal. -->
<app-support-badge></app-support-badge>
<app-support-chat></app-support-chat>
<app-tax-block-banner></app-tax-block-banner>
